import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { DestroyComponent } from 'src/app/components/destroy/destroy.component';
import { DataFilterZdarzeniaService } from 'src/app/services/data-filter-zdarzenia.service';

@Component({
  selector: 'app-zdarzenia-filtry',
  templateUrl: './zdarzenia-filtry.component.html',
  styleUrls: ['./zdarzenia-filtry.component.scss']
})
export class ZdarzeniaFiltryComponent extends DestroyComponent implements OnInit {

  constructor(
    protected readonly fb: FormBuilder,
    public dataFilterService: DataFilterZdarzeniaService
  ) {
    super();
  }

  @Output() pokazWczesniejszeEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  form: FormGroup;
  loading: boolean;
  typZdarzenia = [
    {name: 'Wszystkie', value: []},
    {name: 'Rejestracja sprawy na wniosek', value: ['Rejestracja sprawy na wniosek']},
    {name: 'Rejestracja sprawy z urzędu', value: ['Rejestracja sprawy z urzędu']},
    {name: 'Wpis w rejestrze', value: ['Wpis w rejestrze']},
  ];
  dataDoMin: Date = null;
  togglePanelFiltry = false;

  ngOnInit(): void {
    this.initForm();
    this.initValidation();
  }

  initForm(): void {
    this.form = this.fb.group({
      zdarzenie: [''],
      sygnatura: [''],
      dataOd: [''],
      dataDo: [''],
      numerWpisu: [''],
      pokazWczesniejsze: [null]
    });

    this.form.get('pokazWczesniejsze')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.dataFilterService.loading$.next(value);
        this.pokazWczesniejszeEmitter.emit(value);
      });
  }

  filtruj(): void {
    this.dataFilterService.runFilter(null, this.form.value);
  }

  wyczysc(): void {
    this.form.reset();
    this.filtruj();
  }

  private initValidation() {
    this.form.get('dataOd')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.dataDoMin = new Date(value);
        const dataDo = new Date(this.form?.get('dataDo').value);
        if(this.dataDoMin.getTime() > dataDo.getTime()) {
          this.form?.get('dataDo').setValue(null);
        }
      });
  }
}
